// extracted by mini-css-extract-plugin
module.exports = {"discountSection":"az_vOc","cart":"az_wOc","discountSectionWCorePrice":"az_xOc","strikeprice":"az_yOc","discount":"az_zOc","alignRightStrikethrough":"az_AOc"};